<div class="container-fluid">
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <form [formGroup]="form" (submit)="formSubmit()">
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group">
              <label class="form-control-label" for="descricao"
                >Descrição</label
              >
              <input
                id="descricao"
                type="text"
                class="form-control form-control-alternative"
                formControlName="description"
                placeholder="Descrição"
              />
            </div>
          </div>
        </div>
        <button type="submit" class="btn btn-info">Salvar</button>
      </form>
    </div>
  </div>
</div>
